"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _spauiPopover = require("@tencent/spaui-popover");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Switch =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Switch, _PureComponent);

  /**
   * 属性说明
   * @alias SwitchProps
   * @description 开关选择器。
   * @property {titleline} 默认支持参数
   * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
   * @property {titleline} 基础属性
   * @property {bool} checked=false 是否打开
   * @property {func} onChange 切换状态回调函数<br />onChange(event, checked)
   * @property {string} [size=''] 尺寸*可选值：default, small, large, extralarge*
   * @property {bool} [disabled=false] 是否禁用
   * @property {titleline} 文案
   * @property {string|element} checkedLabel='' 已启用文案
   * @property {string|element} uncheckedLabel='' 未启用文案
   * @property {string|element} commonLabel='' 公共文案
   * @property {string|element} tips='' 提示文案
   * @property {object} [OverlayTriggerProps] OverlayTrigger额外参数
   * @property {object} [PopOverProps] PopOver额外参数
   */
  function Switch(props) {
    var _this;

    _classCallCheck(this, Switch);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Switch).call(this, props));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Switch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          checked = _this$props.checked;

      if ((0, _spauiUtils.isFunction)(onChange)) {
        onChange(event, !checked);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          checked = _this$props2.checked,
          disabled = _this$props2.disabled,
          onClick = _this$props2.onClick,
          size = _this$props2.size,
          checkedLabel = _this$props2.checkedLabel,
          uncheckedLabel = _this$props2.uncheckedLabel,
          commonLabel = _this$props2.commonLabel,
          htmlref = _this$props2.htmlref,
          htmlRef = _this$props2.htmlRef,
          onMouseOut = _this$props2.onMouseOut,
          onMouseOver = _this$props2.onMouseOver,
          tips = _this$props2.tips,
          tipsClassName = _this$props2.tipsClassName,
          PopOverProps = _this$props2.PopOverProps,
          OverlayTriggerProps = _this$props2.OverlayTriggerProps;
      return _react["default"].createElement("label", _extends({}, (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])('spaui-switch', {
          disabled: disabled,
          'spaui-switch-checked': checked,
          'size-sm': size === 'small',
          'size-lg': size === 'large',
          'size-xlg': size === 'extralarge',
          'has-label': checkedLabel || uncheckedLabel,
          'has-common-label': commonLabel
        })
      }, Switch), {
        onClick: onClick,
        role: "switch",
        "aria-checked": checked,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        ref: htmlref || htmlRef
      }), _react["default"].createElement("input", {
        type: "checkbox",
        className: "spaui-switch-input",
        checked: checked,
        disabled: disabled,
        onChange: this.handleChange
      }), _react["default"].createElement(_spauiPopover.OverlayTrigger, _extends({
        placement: "top",
        disabled: !tips,
        overlay: _react["default"].createElement(_spauiPopover.PopOver, _extends({
          className: tipsClassName
        }, PopOverProps), tips)
      }, OverlayTriggerProps), _react["default"].createElement("span", {
        className: "spaui-switch-helper"
      })), checkedLabel || uncheckedLabel ? _react["default"].createElement("span", {
        className: "spaui-switch-text"
      }, checked ? checkedLabel : uncheckedLabel) : null, commonLabel ? _react["default"].createElement("span", {
        className: "spaui-switch-common"
      }, commonLabel) : null);
    }
  }]);

  return Switch;
}(_react.PureComponent); // 组件标记


_defineProperty(Switch, "propTypes", {
  checked: _spauiUtils.PropTypes.bool.isRequired,
  onChange: _spauiUtils.PropTypes.func.isRequired,
  disabled: _spauiUtils.PropTypes.bool,
  size: _spauiUtils.PropTypes.string,
  onClick: _spauiUtils.PropTypes.func,
  checkedLabel: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.string, _spauiUtils.PropTypes.element]),
  uncheckedLabel: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.string, _spauiUtils.PropTypes.element]),
  commonLabel: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.string, _spauiUtils.PropTypes.element]),
  tips: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.string, _spauiUtils.PropTypes.element]),
  tipsClassName: _spauiUtils.PropTypes.string,
  OverlayTriggerProps: _spauiUtils.PropTypes.object,
  PopOverProps: _spauiUtils.PropTypes.object
});

_defineProperty(Switch, "defaultProps", {
  checked: false,
  disabled: false,
  szie: 'default',
  checkedLabel: '',
  uncheckedLabel: '',
  tips: null,
  tipsClassName: ''
});

(0, _spauiUtils.setComponentMark)(Switch, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Switch;
exports["default"] = _default;